import { Divider } from '@mui/material';
import { Row, Table } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../../api/config';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import { Load, Medication } from '../../../../types';
import { getSingleColorTagStyle } from '../../utils/drafts-loads-utils';
import { DraftLoadFilter } from './draft-load-filter';
import { GlobalFilter, GlobalFilterItem, GlobalFilterObject } from '../../hooks/use-draft-load-table';

export type MedicationFilter = GlobalFilterObject<'medicationFilter', number>;

interface MedicationFilterProps {
    table: Table<Load>;
}

export const MedicationFilter = (props: MedicationFilterProps) => {
    const { table } = props;
    const { data: medications = [] } = useOrganizationQuery<Medication[]>(OrgQueryKeys.medications);

    function medicationFilterFn(row: Row<Load>, medicationId: number) {
        const load = row.original;
        return load.stops.some(stop => stop.medicationIds?.some(id => id === medicationId));
    }
    
    function handleMedicationChange(medicationId: number) {
        table.setGlobalFilter((currentGlobalFilter: GlobalFilter): GlobalFilter => {
            const hasMedication = currentGlobalFilter?.some(item => item.type === 'medicationFilter' && item.value === medicationId);

            if (hasMedication) {
                return currentGlobalFilter?.filter(item => !(item.type === 'medicationFilter' && item.value === medicationId));
            } else {
                return [
                    ...(currentGlobalFilter || []), {
                        type: 'medicationFilter',
                        label: medications.find(med => med.id === medicationId)?.name || '',
                        value: medicationId,
                        filterFn: medicationFilterFn,
                    },
                ];
            }
        });

    }

    const globalFilter: GlobalFilter = table.getState().globalFilter;
    const medicationFilters = globalFilter?.filter((item: GlobalFilterItem) => item.type === 'medicationFilter');

    return medications.length > 0 && (
        <>
            <Divider />
            <DraftLoadFilter
                label={L.medications()}
                items={medications}
                selectedIds={medicationFilters?.map((item: MedicationFilter) => item.value) || []}
                itemLabelFn={(medication) => medication.name}
                optionStyleFn={(medicationId) => getSingleColorTagStyle(medicationId, medications)}
                onChange={handleMedicationChange}
            />
        </>
    );
};